<template>
  <div class="people-container">
    <el-header>
      <h1>People</h1>
    </el-header>
    <el-main>
      <el-tabs v-model="activeTab" class="demo-tabs" style="width: 100%; position: sticky; top: 0px; background: white; z-index: 100">
        <el-tab-pane label="For Exchange" name="exchange">
          <div class="users-container">
            <User
              v-for="userData in usersForExchange" 
              :key="(userData.user_info._id.$oid || userData.user_info._id.$id)"
              :userData="userData"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="My Friends" name="friends">
          <div class="users-container">
            <User
              v-for="userData in friendUsers" 
              :key="(userData.user_info._id.$oid || userData.user_info._id.$id)"
              :userData="userData"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="Followed" name="followed">
          <div class="users-container">
            <User
              v-for="userData in usersFollowed" 
              :key="(userData.user_info._id.$oid || userData.user_info._id.$id)"
              :userData="userData"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
import Post from '@/components/Post.vue'
import User from '@/components/User.vue'
import { postRequest } from '@/apis/front'

export default {
  name: 'People',
  components: {
    Post,
    User
  },
  data() {
    return {
      activeTab: 'exchange',
      usersForExchange: [],
      lastTime: new Date().getTime(),
      friendUsers: [],
      usersFollowed: []
    }
  },
  methods: {
    handleLike(postId) {
      console.log('Like post:', postId)
    },
    handleComment(postId) {
      console.log('Comment on post:', postId)
    },
    async fetchUsersForExchange() {
      const response = await postRequest('getUsersForExchange', {
        user_id: this.$store.state.user_id || '',
        time: this.lastTime
      })
      
      if (response.data.code === 0) {
        this.usersForExchange = response.data.data
      } else {
        this.$message.error(response.data.msg || 'Failed to fetch users for exchange')
      }
    }
  },
  mounted() {
    this.fetchUsersForExchange()
  }
}
</script>

<style scoped>
.people-container {
  width: 100%;
}

.el-header {
  background-color: #409EFF;
  color: white;
  text-align: center;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-header h1 {
  margin: 0;
}

.el-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 120px);
  overflow-y: auto;
}

.users-container {
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;
}
</style> 